import { useEffect, useRef } from 'react'
import { createFoodSafetyLatestRequest } from 'src/utils/foodSafetyLatestRequest'

/** One latest-request tracker per mounted screen; unmount drops late answers. */
export default function useFoodSafetyLatestRequest() {
  const ref = useRef(null)
  if (!ref.current) ref.current = createFoodSafetyLatestRequest()
  useEffect(() => {
    const tracker = ref.current
    return () => tracker.cancel()
  }, [])
  return ref.current
}
